// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'print-solid';

export const Component = () => (
  <path d='M18.673 2.485v7.328H5.933V2.484c0-.431.144-.766.432-1.054A1.408 1.408 0 0 1 7.419 1h9.77c.431 0 .766.144 1.054.431.287.288.431.623.431 1.054h-.001ZM5.933 19.631v4.407c0 .335.144.478.479.478h11.781c.335 0 .479-.143.479-.478V19.63H5.932Zm17.672-7.376v8.86c0 .432-.143.767-.43 1.055a1.408 1.408 0 0 1-1.055.43h-2.442v-2.969h1.437c.335 0 .526-.143.526-.479 0-.335-.191-.479-.526-.479H3.49c-.336 0-.527.144-.527.48 0 .335.191.478.527.478h1.436v2.97H2.485c-.431 0-.766-.144-1.054-.431A1.408 1.408 0 0 1 1 21.116v-8.86c0-.383.144-.72.431-1.006a1.411 1.411 0 0 1 1.054-.431h19.636c.431 0 .767.143 1.054.431.287.287.431.623.431 1.005ZM6.891 14.22c0-.336-.144-.48-.48-.48H4.449c-.335 0-.478.144-.478.48 0 .335.143.526.478.526h1.964c.335 0 .479-.191.479-.526Z' />
);

export const viewBox = '0 0 25 25';
